<template>
  <div
    class="community-recommendations"
    data-test-id="community-recommendations"
  >
    <div class="community-hub__section-header">
      <h2
        class="community-hub__section-heading"
        data-test-id="community-recommendations-heading"
      >{{ headingText }}</h2>
    </div>
    <p
      class="community-hub__section-greeting"
      data-test-id="community-recommendations-greeting"
    >{{ greetingText }}</p>
    <loading-spinner v-if="loading !== 0" />
    <div v-else class="community-recommendations__team">
      <ul class="community-recommendations__team-list list-reset">
        <team-member
          v-for="user in userRecommendations"
          :key="`community-recommendations-${user.id}`"
          :user="user"
        />
      </ul>
      <button
        v-if="userIsLoggedIn"
        class="community-recommendations__cta"
        data-test-id="community-recommendations-cta"
        @click="showMore"
      >View more
      </button>
      <router-link
        v-else
        :to="advocateLandingPath"
        class="community-recommendations__cta"
        data-test-id="community-recommendations-cta"
      >
        See the full team
        <icon-component
          name="caret"
          title="caret icon"
          class="community-recommendations__cta-icon icon--smallest"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import TeamMember from '@/components/User/TeamMember.vue';
import { mapGetters } from 'vuex';
import { USER_RECOMMENDATIONS_QUERY } from '@/graphql/queries/user-queries';

export default {
  name: 'CommunityRecommendations',
  components: {
    TeamMember,
  },
  data() {
    return {
      loading: 0,
      listLimit: 4,
      advocateLandingPath: this.$site.settings.advocate_landing_path || 'patient-advocates',
    };
  },
  computed: {
    ...mapGetters(['userIsLoggedIn']),
    headingText() {
      if (this.userIsLoggedIn) {
        return 'Meet Other Community Members';
      }
      return 'Meet the Team';
    },
    greetingText() {
      const communityHub = this.$site.settings.community_hub || {};
      if (this.userIsLoggedIn) {
        return `${communityHub.recommendation_greeting_logged_in}` || '';
      }
      return `${communityHub.recommendation_greeting_logged_out}` || '';
    },
  },
  watch: {
    userIsLoggedIn() {
      this.$forceUpdate();
      this.$apollo.queries.userRecommendations.refetch();
    },
  },
  methods: {
    showMore() {
      this.listLimit = 8;
    },
  },
  apollo: {
    userRecommendations: {
      query: USER_RECOMMENDATIONS_QUERY,
      variables() {
        // Note that cacheKey is not an argument on the query, it is used to force
        // the query to re-run on the network if the currentUser's login state changes
        return {
          limit: this.listLimit,
          cacheKey: this.userIsLoggedIn.toString(),
        };
      },
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_community-recommendations';
</style>
